const notificationAndResponseEn = {
  detail: {
    backToList: 'Back to list',
    existing: 'Existing',
    policy: {
      basicSection: 'Basic Information',
      breadcrumbPolicies: 'Notification Policies',
      createTitle: 'Create Notification Policy',
      description: 'Description',
      edit: 'Edit',
      editTitle: 'Edit Notification Policy',
      enabledOff: 'OFF',
      enabledOn: 'ON',
      loadError: 'Failed to load notification policy.',
      message: 'Message',
      messageDialog: {
        body: 'Body',
        subject: 'Subject',
        subjectOptional: 'Optional',
        title: 'Edit Message'
      },
      messageVariables: {
        assignee: {
          name: 'Assignee name'
        },
        operator: {
          name: 'Initiator name'
        },
        package: {
          name: 'Business package name'
        },
        task: {
          name: 'Task name'
        }
      },
      nameLabel: 'Name',
      noDescription: '—',
      notSet: 'Not set',
      notificationSettings: 'Notification Settings',
      notificationSettingsSection: 'Notification Settings',
      onCount: '{{on}} / {{total}} ON',
      recipientOptions: {
        assignee: 'Assignee',
        operator: 'Initiator'
      },
      recipients: 'Recipients',
      recipientsDialog: {
        title: 'Select Recipients'
      },
      saved: 'Saved.',
      selectedPatternDetail: 'Selected Pattern Detail',
      taskTypes: {
        application: 'Application',
        approval: 'Approval',
        confirmation: 'Confirmation',
        formInput: 'Form Input',
        todo: 'To Do'
      },
      triggers: {
        end: 'End',
        start: 'Start'
      },
      typeCount: '{{count}} types',
      unsupportedDomainSettings: 'Notification settings UI for this domain is not implemented yet (alert domain coming later).',
      viewTitle: 'Notification Policy Detail'
    }
  },
  forces: {
    gaForce: 'GA Force',
    hrForce: 'HR Force',
    itForce: 'IT Force',
    liForce: 'LI Force'
  },
  policies: {
    columns: {
      description: 'Description',
      name: 'Name'
    },
    create: 'Create',
    delete: 'Delete',
    emptyMessage: 'No notification policies found.'
  },
  products: {
    contractorCore: 'Contractor Core',
    gaOperationCore: 'GA Operation Core',
    itOperationCore: 'IT Operation Core',
    laborCore: 'Labor Core',
    stacktracePn: 'Stacktrace PN',
    stacktraceQa: 'Stacktrace QA'
  },
  rules: {
    assignDialog: {
      notSet: 'Not set (unassign)',
      saved: 'Notification policy assignment saved',
      title: 'Assign Notification Policy: {{packageName}}'
    },
    columns: {
      force: 'Force',
      notificationPolicy: 'Notification Policy',
      operationPackage: 'Operation Package',
      product: 'Product'
    },
    edit: 'Edit',
    emptyMessage: 'No notification rules found.',
    filters: {
      allForces: 'All Forces',
      allProducts: 'All Products',
      forcePlaceholder: 'Force',
      productPlaceholder: 'Product'
    },
    notSet: 'Not Set',
    searchPlaceholder: 'Search business packages...'
  },
  tabs: {
    notificationChannels: 'Notification Channels',
    notificationPolicies: 'Notification Policies',
    notificationRules: 'Notification Rules',
    settings: 'Settings'
  },
  targetTabs: {
    alert: 'Alert',
    businessPackage: 'Business Package'
  },
  title: 'Notification & Response'
};
export default notificationAndResponseEn;